<template>
  <div>
    <div class="search-one">
      <div class="search-item">
        客户编号
        <Input class='ml10 mr20 w200' v-model="screen_data.client_code" placeholder="请输入客户编号" clearable />
        账单单号
        <Input class='ml10 mr20 w200' v-model="screen_data.bill_no" placeholder="请输入账单单号" clearable />
        仓库
        <Select v-model="warehouse_id" @on-change="warehouseselectevent" class="w200" placeholder="请选择库房" clearable>
          <Option v-for="(option, index) in houseList" :value="option.warehouse_id" :key="index">
            {{option.warehouse_name}}
          </Option>
        </Select>
      </div>
      <div class="search-item">
        支付状态
        <Select v-model="screen_data.pay_status" class="w100 mr20" clearable>
          <Option v-for="(option, index) in statusList" :value="option.value" :key="index">{{option.label}}
          </Option>
        </Select>
        创建时间
        <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200' clearable></DatePicker>-
        <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200' clearable></DatePicker>
        <button class="ivu-btn ivu-btn-primary fr ml20" @click="batchPay">批量支付</button>
        <!-- <button class="ivu-btn ivu-btn-primary fr ml20" @click="exportData">导出</button> -->
        <button class="ivu-btn ivu-btn-primary fr" @click="search">搜索</button>
      </div>
    </div>
    <div>
      <Table ref="data_list" :loading="loading" class="mt20" border :columns="table_data.columns"
        :data="table_data.data">
        <template slot-scope="{ row, index }" slot="opeate">
          <span @click="detail(row)" class="blue">详情</span>
          <span v-if="row.pay_status==0" @click="pay(row)" class="blue">支付</span>
        </template>
      </Table>
      <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>
    </div>

    <Modal :title="title" v-model="show_detail" width="1000">
      <Table class="mt20" border :columns="detail_columns" :data="detail_list">
        <template slot-scope="{ row, index }" slot="images">
          <span class="item-img mr10 fl" v-for="(v,i) in row.image_arr" :key="i" :src="v">
            <el-image style="width: auto; height: 30px;margin-top: 10px;" :src="v" :preview-src-list="row.image_arr">
            </el-image>
            <Icon v-if="row.$isEdit" @click="delImg(index,i)" class="i-colse" type="ios-close-circle" size="16" />
          </span>
        </template>
      </Table>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
  import Paging from '@/components/common/paging'
  export default {
    components: {
      Paging,
    },
    data() {
      return {
        houseList: [],
        warehouse_id: '',
        table_data: { //列表数据
          columns: [],
          data: []
        },
        loading: true, //是否加载中
        screen_data: { //传入接口的搜索条件
          pageNum: 1,
          pageSize: 10,
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
        statusList: [{
          value: '',
          label: '全部'
        }, { //10-待结算，20-已结算，-10-已作废
          value: 0,
          label: '待付款'
        }, {
          value: 1,
          label: '已付款'
        }, {
          value: '-1',
          label: '已作废'
        }],
        detail_columns: [{
          title: 'SKU',
          key: 'sku',
          minWidth: 100,
          tooltip: true
        }, {
          title: '产品名称',
          key: 'product_name',
          minWidth: 100,
          tooltip: true
        }, {
          title: '尺寸',
          key: 'size',
          minWidth: 100,
          tooltip: true
        }, {
          title: '颜色',
          key: 'color',
          minWidth: 100,
          tooltip: true
        }, {
          title: '图片',
          slot: 'images',
          width: 100,
        }, {
          title: '备注',
          key: 'remark',
          minWidth: 100,
          tooltip: true
        }, {
          title: '创建时间',
          key: 'create_date',
          minWidth: 100,
          tooltip: true
        }, {
          title: '质检实际数量',
          key: 'count',
          minWidth: 100,
          tooltip: true
        }, {
          title: '状态',
          minWidth: 100,
          render: (h, params) => {
            let txt = '-'
            //状态（0-待确定， 1是合格，-1是不合格）
            if (params.row.status == 0) {
              txt = '待确定'
            } else if (params.row.status == 1) {
              txt = '合格'
            } else if (params.row.status == -1) {
              txt = '不合格'
            }
            return h("span", txt);
          }
        }],
        detail_list: [],
        show_detail: false,
        title: ''
      }
    },
    methods: {
      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList(this.active);
      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList(this.active);
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList(this.active);
      },
      sDateChange(e) {
        if (e) {
          this.screen_data.create_start_date = e + ' 00:00:00'
        } else {
          this.screen_data.create_start_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screen_data.create_end_date = e + ' 23:59:59'
        } else {
          this.screen_data.create_end_date = ''
        }
      },
      getList() {
        this.$axios.get('/ClientBill/fee/check/bill', {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            res.data.forEach(item => {
              item._disabled = true; //默认禁用
              if (item.pay_status == 0) { //待支付
                item._disabled = false
              }
            })
            this.table_data.data = res.data;
          } else {
            this.table_data.data = [];
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      detail(data) {
        this.title = '质检单号' + data.check_bill_no + '详情'
        this.$axios.get("/zj/check/bill/list/detail?check_bill_code=" + data.check_bill_no).then(res => {
          if (res.success && res.data && res.data.length) {
            res.data.forEach(v => {
              v.image_arr = []
              if (v.image_url) {
                v.image_arr.push(v.image_url)
              }
            })
            this.detail_list = res.data;
          } else {
            this.detail_list = []
          }
          this.show_detail = true;
        })
      },
      //质检单号，子账户编号，所属仓库，姓名，
      setColumns() {
        let arr = [{
            type: 'selection',
            width: 60,
            align: 'center',
            fixed: 'left'
          }, {
            title: '质检单号',
            key: 'check_bill_no',
            tooltip: true,
            width: 170,
          }, {
            title: '子账户编号',
            key: 'client_code',
            tooltip: true,
            width: 150,
          },
          {
            title: '所属仓库',
            key: 'warehouse_name',
            tooltip: true,
            width: 150,
          },
          {
            title: '客户姓名',
            key: 'client_name',
            tooltip: true,
            width: 150,
          }, {
            title: 'SKU数',
            key: 'sku_count',
            width: 150,
          }, {
            title: '商品总数',
            key: 'product_count',
            width: 150,
          }, {
            title: '总金额(USD)',
            key: 'total_fee',
            width: 150,
          },
          {
            title: "状态",
            key: "pay_status",
            width: 100,
            render: (h, params) => {
              let status = params.row.pay_status;
              if (status == 0) {
                return h("span", {
                  style: {
                    color: 'red'
                  }
                }, "待支付");
              } else if (status == 1) {
                return h("span", {
                  style: {
                    color: 'green'
                  }
                }, "已支付");
              } else if (status == -1) {
                return h("span", "已作废");
              }
            }
          }, {
            title: '支付时间',
            key: 'pay_date',
            width: 190,
            tooltip: true
          }, {
            title: '费用产生日期',
            key: 'create_date',
            width: 190,
            tooltip: true
          }, {
            title: '操作',
            slot: 'opeate',
            fixed: 'right',
            width: 150
          }
        ];
        return arr;
      },
      exportData() {
        this.$axios.get('/ClientBill/fee/fh/out/bill/excel', {
          params: this.screen_data
        }).then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      },
      pay(data) {
        const that = this;
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确定要支付账单吗？</p><p>此操作将无法撤销！</p>',
          onOk: () => {
            that.payDirectly(data);
          },
          onCancel: () => {

          }
        });
      },
      payDirectly(data) {
        this.$axios.post('/ClientBill/fee/pay/check/bill?check_bill_no=' + data.check_bill_no).then(res => {
          if (res.success) {
            this.$Message.success('支付成功');
            this.getList();
          }
        })
      },
      payFn(check_bill_no) {
        return new Promise((resolve, reject) => {
          this.$axios.post('/ClientBill/fee/pay/check/bill', this.$qs.stringify({
            check_bill_no: check_bill_no
          }), {
            headers: {
              noShowError: true
            }
          }).then(res => {
            resolve(res)
          })
        })
      },
      batchPay() {
        const _this = this;
        let items = this.$refs.data_list.getSelection();
        console.log(items)
        if (items.length == 0) {
          this.$Message.error('请选择要支付的账单');
          return;
        }
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确定要支付账单吗？</p><p>此操作将无法撤销！</p>',
          onOk: () => {
            let count = 0;//请求成功次数
            let msg = '';
            for (let i = 0; i < items.length; i++) {
              _this.payFn(items[i].check_bill_no).then(res => {
                if (res.success) {
                  count++;
                  if (count == items.length) {
                    _this.$Message.success('支付成功');
                    _this.getList()
                  }
                } else {
                  msg = "质检单号"+ items[i].check_bill_no + '支付失败：' + res.msg;
                  _this.$Message.info(msg)
                }
              })
            }
          },
          onCancel: () => {

          }
        });
      },
      warehouseselectevent(e) {
        if (e == undefined) e = "";
        this.screen_data.warehouse_id = e;
        console.log("仓库id产生编号：" + e)
      },
      init() {
        this.table_data.columns = this.setColumns()
        this.getList()
        //进行仓库查询 houseList
        this.$axios.get("warehouse/list").then(res => {
          if (res.success && res.data) {
            this.houseList = res.data;
          }
        })

      }
    },
    created() {
      this.init()
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/finance/bill/zhijiandan.vue